export const generateSelectItemsWithDefaultElement = (
  defaultElement,
  items,
) => {
  return [{ id: -1, value: "", label: defaultElement }, ...items];
};
